<template>
  <el-col
    :span="24"
    id="banks"
    v-loading.body="changingPage && !navigating"
    element-loading-text="Fetching page...">
    <el-row type="flex" justify="start" align="middle" id="banks-header">
      <HeaderInfoText :colspan="9" title="BANKS" :meta="meta" :selection="selection"></HeaderInfoText>
      <el-col :span="6">
        <el-row type="flex" justify="center" v-if="meta.count > 20">
          <el-pagination
            layout="prev, pager, next, jumper"
            :total="meta.count"
            :page-size="20"
            :current-page.sync="currentPage">
          </el-pagination>
        </el-row>
      </el-col>
      <el-col :span="9" class="h-padded right-aligned-col">
        <el-button type="primary" icon="plus" @click="createNewModel"></el-button>
      </el-col>
    </el-row>
    <el-row type="flex" justify="end" align="middle">
      <el-col :span="24">
        <el-table
          v-if="meta.count && !changingPage"
          id="banks-table"
          :data="pageData"
          border
          style="width: 100%; z-index: 0;"
          :maxHeight="tableHeight"
          :ref="`${endpoint}Table`"
          :row-class-name="tableRowClassName">
          <el-table-column prop="code" label="Code" align="center" width="120">
            <template slot-scope="scope">
              <el-row type="flex" justify="center">
                <a class="link-mock" @click="editExistingModel(scope.row.id)">
                  {{ scope.row.code }}
                </a>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="Name" align="left" fit>
            <template slot-scope="scope">
              <el-row type="flex">
                <a class="link-mock" @click="editExistingModel(scope.row.id)">
                  {{ scope.row.name }}
                </a>
              </el-row>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-dialog
      :title="editMode.active ? `Edit bank` : 'Create New Bank'"
      size="small"
      :visible="dialogFormVisible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :show-close="false">
      <NewEntityForm
        :modalOpen="dialogFormVisible"
        :fields="fields"
        :form.sync="form"
        :idPrefix="'a-'"
        ref="form"
        v-loading.body="loadingForm" element-loading-text="Loading..."
        @formChanged="trackFormChange">
      </NewEntityForm>
      <span slot="footer" class="dialog-footer">
        <el-button :disabled="saving || !!updating" @click="closeCreateOrEditModal">Cancel</el-button>
        <el-button :loading="saving || !!updating" type="primary" @click="submitForm">Submit</el-button>
      </span>
    </el-dialog>
  </el-col>
</template>

<script>
  import { mapGetters } from 'vuex'
  import NewEntityForm from '@/components/NewEntityForm.vue'
  import HeaderInfoText from '@/components/HeaderInfoText'
  import { validate, checkAddressRequirements } from '@/utils/helpers/Validate'
  import { notify } from '@/utils/helpers/Notify'
  import { handleSelectionChange, createNewModel } from '@/components/RouteComponents/commonFunctions'
  import { systemViewMixins } from '@/Mixins/SystemViewMixins'
  import cityMixin from '@/Mixins/CityMixin'
  import { payload as bankActionPayload } from '@/components/RouteComponents/Banks/actionPayload'
  import { payload as addressPayload } from '@/components/RouteComponents/Addresses/actionPayload'
  import { payload as seriesActionPayload } from '@/components/RouteComponents/Series/actionPayload'
  import { payload as setActionPayload } from '@/components/RouteComponents/Sets/actionPayload'
  import { payload as locationActionPayload } from '@/components/RouteComponents/Locations/actionPayload'
  import { DataLoader } from '@/utils/helpers/DataLoader/DataLoader'
  import store from '@/store/store'
  import Crypto from 'crypto'

  export default {
    components: {
      NewEntityForm,
      HeaderInfoText
    },
    mixins: [ systemViewMixins, cityMixin ],
    data () {
      return {
        tableHeight: 1000,
        selection: [],
        dialogFormVisible: false,
        formInitState: {
          code: '',
          name: '',
          description: '',
          account_number: '',
          routing_number: '',
          account_fraction: '',
          currency: { label: '', value: '' },
          contact_name: '',
          branch_number: '',
          address_physical: '',
          address_physical_line1: '',
          address_physical_line2: '',
          address_physical_city: '',
          address_physical_state: { label: '', value: '' },
          address_physical_postal: '',
          address_mailing: '',
          address_mailing_line1: '',
          address_mailing_line2: '',
          address_mailing_city: '',
          address_mailing_state: { label: '', value: '' },
          address_mailing_postal: '',
          phone: '',
          fax: '',
          email: '',
          check_preferred_template: '',
          check_range_start: '',
          check_range_end: '',
          eft_range_start: '',
          eft_range_end: '',
          wt_range_start: '',
          wt_range_end: '',
          default_account_cash: { label: '', value: '' },
          default_account_clearing: { label: '', value: '' },
          default_account_deposits: { label: '', value: '' },
          default_account_discount: { label: '', value: '' },
          check_copies: 1,
          eft_template: '',
          eft_copies: 1,
          wt_template: '',
          wt_copies: 1,
          series: { label: '', value: '' },
          location: { label: '', value: '' },
          set: { label: '', value: '' },
          positive_pay_email_notification: ''
        },
        form: {
          code: '',
          name: '',
          description: '',
          account_number: '',
          routing_number: '',
          account_fraction: '',
          currency: { label: '', value: '' },
          contact_name: '',
          branch_number: '',
          address_physical: '',
          address_physical_line1: '',
          address_physical_line2: '',
          address_physical_city: '',
          address_physical_state: { label: '', value: '' },
          address_physical_postal: '',
          address_mailing: '',
          address_mailing_line1: '',
          address_mailing_line2: '',
          address_mailing_city: '',
          address_mailing_state: { label: '', value: '' },
          address_mailing_postal: '',
          phone: '',
          fax: '',
          email: '',
          check_preferred_template: '',
          check_range_start: '',
          check_range_end: '',
          eft_range_start: '',
          eft_range_end: '',
          wt_range_start: '',
          wt_range_end: '',
          default_account_cash: { label: '', value: '' },
          default_account_clearing: { label: '', value: '' },
          default_account_deposits: { label: '', value: '' },
          default_account_discount: { label: '', value: '' },
          check_copies: 1,
          eft_template: '',
          eft_copies: 1,
          wt_template: '',
          wt_copies: 1,
          series: { label: '', value: '' },
          location: { label: '', value: '' },
          set: { label: '', value: '' },
          positive_pay_email_notification: ''
        },
        currentPage: 1,
        editMode: { active: false, modelId: null },
        changingPage: false,
        headers: undefined,
        instanceUrl: undefined,
        isCityModel: undefined,
        loadingForm: false
      }
    },
    methods: {
      /**
       * Handles transaction selection
       * @param selection
       */
      handleSelectionChange (selection) {
        handleSelectionChange(this, selection)
      },
      checkAddressRequirements () {
        return true
      },
      async submitAddresses () {
        await this.autoFillAddresses()
        let promises = []
        const aFields = this.fields.filter(field => field.name.includes('address'))
        const m = aFields.filter(field => field.name.includes('mailing'))
        const p = aFields.filter(field => field.name.includes('physical'))

        let all = [m, p]
        for await (let field of all) {
          const name = field[0].name.split('_')[0] + '_' + field[0].name.split('_')[1]
          const hasAtLeastOneField = field.some(v => {
            if (this.form[v.name].hasOwnProperty('value')) return !!this.form[v.name].value
            return !!this.form[v.name]
          })
          if (!hasAtLeastOneField) return
          if (checkAddressRequirements(field, this.form)) {
            let subsetForm = {}
            // let cityId = null
            for (let j in field) {
              const val = this.form[field[j].name]
              subsetForm[field[j].name.split('_')[2]] = val.hasOwnProperty('value') ? val.value : val
            }

            if (this.isCityModel && typeof subsetForm.city === 'string') {
              let cityId = await this.getCityByNameAndState(subsetForm.city, subsetForm.state)
              if (cityId) {
                subsetForm.city = cityId
              } else {
                // Create City
                let payload = {
                  name: subsetForm.city,
                  code: `${Crypto.randomBytes(5).toString('hex')}`,
                  state: subsetForm.state
                }
                let cityId = await this.addNewCity(payload)
                subsetForm.city = cityId
              }
            }

            promises.push(this.$store.dispatch('saveAddress', subsetForm)
              .then(r => {
                this.form[name] = r.id
                return r
              })
              .catch(e => console.log(e)))
          } else {
            return notify(this, 'warning', 'Please specify valid address attributes')
          }
        }
        try {
          return await Promise.all(promises)
        } catch (e) {
          this.$notify({ title: 'Error', message: 'Error submitting addresses', type: 'error' })
          return e
        }
      },
      async submitForm () {
        if (this.isCityModel === undefined) {
          await this.checkCityModel()
        }
        try {
          await this.submitAddresses()
          let form = { ...this.form }
          form.eft_range_start = form.eft_range_start.toString()
          form.eft_range_end = form.eft_range_end.toString()
          form.wt_range_start = form.wt_range_start.toString()
          form.wt_range_end = form.wt_range_end.toString()
          form.check_range_start = form.check_range_start.toString()
          form.check_range_end = form.check_range_end.toString()

          if (this.isCityModel && form.address_mailing_state && form.address_mailing_city) {
            let cityState = {
              city: form.address_mailing_city,
              state: form.address_mailing_state.value
            }
            await this.getCityByNameAndState(cityState.city, cityState.state)
            .then((cityId) => {
              form.address_mailing_city = cityId
              form.address_physical_city = cityId
            })
          }

          this.finishSubmission(form)
        } catch (e) {
          console.log(e)
          notify(this, 'warning', 'Error saving bank')
        }
      },
      async finishSubmission (form) {
        let validationErrors = validate(form, this.fields)
        if (!validationErrors.messages) {
          for (let f in this.form) {
            if (['_mailing_', '_physical_'].some(v => f.includes(v))) {
              delete form[f]
            }
          }
          form = this.handleNestedValueFields(form)
          form = this.formatPostOrPatchRequest(form)
          const action = this.editMode.active
            ? this.$store.dispatch('updateBank', {id: this.editMode.modelId, data: form})
            : this.$store.dispatch('saveBank', form)
          const resp = await action
          if (!(resp && resp.id)) {
            throw new Error()
          }

          this.$store.dispatch('isEditingForm', false)
          this.closeCreateOrEditModal()
          this.createdNotif = this.$notify({
            title: 'Success',
            message: `Bank ${resp.name ? resp.name : resp.code} saved. Click to view.`,
            type: 'success',
            onClick: () => {
              this.editExistingModel(resp.id)
              this.createdNotif.close()
              this.createdNotif = null
            }
          })
          this.highlightNewModel(resp.id)
        } else {
          let offset = 0                                                                        // Set offset so that notifs don't overlap each other
          validationErrors.messages.map(v => {                                                // Render validation error notifs
            this.$notify({
              title: 'Warning',
              message: v,
              type: 'warning',
              offset: offset
            })
            offset += 100
          })
        }
      },
      async autoFillAddresses () {
        const hasAtLeastOneField = (group) => group.some(v => {
          if (this.form[v].hasOwnProperty('value')) return !!this.form[v].value
          return !!this.form[v]
        })
        const m = this.fields.filter(v => v.name.includes('address_mailing_')).map(v => v.name)
        const b = this.fields.filter(v => v.name.includes('address_physical_')).map(v => v.name)
        const all = [m, b]
        const rem = []
        for (let i = 0; i < all.length; i++) {
          if (!hasAtLeastOneField(all[i])) rem.push(...all[i])
        }
        if (rem.length) {
          for await (let fieldName of rem) {
            const fieldSuffix = fieldName.split('_')[2]
            if (fieldSuffix === 'state') {
              this.form[fieldName].label = this.form[`address_mailing_${fieldSuffix}`].label
              this.form[fieldName].value = this.form[`address_mailing_${fieldSuffix}`].value
            } else if (fieldSuffix === ' city') {
              await this.getCityByNameAndState(this.form[fieldName], this.field.address_mailing_state)
              .then((cityId) => {
                this.form[`address_mailing_${fieldSuffix}`] = cityId
              })
            } else {
              this.form[fieldName] = this.form[`address_mailing_${fieldSuffix}`]
            }
          }
        }
      },
      closeCreateOrEditModal () {
        this.resetForm()
        this.handleDialogVisible(false)
      },
      handleDialogVisible (visibleState) {
        this.dialogFormVisible = visibleState
        this.$store.dispatch('isEditingForm', false)
      },
      /**
       * Resets editMode data, resets form to initial state, and displays the
       * modal to create a new model
       */
      createNewModel () {
        createNewModel(this)
      },
      /**
       * Populates form field when an existing model is selected for editing
       * @param modelId
       */
      async editExistingModel (modelId) {
        if (this.isCityModel === undefined) {
          await this.checkCityModel()
        }

        this.editMode.active = true
        this.editMode.modelId = modelId
        const model = this.getBankById(modelId)
        this.dialogFormVisible = true
        this.loadingForm = true
        let bankAccounts = [model.default_account_cash, model.default_account_clearing, model.default_account_deposits, model.default_account_discount]
        await this.$store.dispatch('fetchAccountsWithQuery', { id__in: [...new Set(bankAccounts)], page_size: bankAccounts.length })

        for await (let p of Object.keys(model)) {
          if ((!model.hasOwnProperty(p) || !model[p]) || !Object.keys(this.form).includes(p)) continue
          switch (p) {
            case 'currency':
              this.form[p] = {
                label: model.currency ? this.getCurrencyById(model.currency).code : '',
                value: model.currency ? this.getCurrencyById(model.currency).id : ''
              }
              break
            case 'default_account_cash':
            case 'default_account_clearing':
            case 'default_account_deposits':
            case 'default_account_discount':
              this.form[p] = {
                label: model[p] ? this.getAccountById(model[p]).code : '',
                value: model[p] ? this.getAccountById(model[p]).id : ''
              }
              break
            case 'address_mailing':
            case 'address_physical':
              await this.$store.dispatch('fetchAddressesWithQuery', { id: model[p] })
              const addressModel = await this.getAddressById(model[p])
              if (!addressModel) break
              for (let a of Object.keys(addressModel)) {
                if (a === 'state' && this.getStateById(addressModel[a])) {
                  this.form[p + `_${a}`]['label'] = this.getStateById(addressModel[a]).name
                  this.form[p + `_${a}`]['value'] = this.getStateById(addressModel[a]).id
                // Handle new city model here
                } else if (a === 'city' && this.isCityModel && !isNaN(addressModel[a])) {
                  const cityName = await this.getCityById(addressModel[a])
                  this.form[p + `_${a}`] = cityName
                } else {
                  this.form[p + `_${a}`] = addressModel[a]
                }
              }
              break
            case 'series':
              this.form[p] = {
                label: model[p] ? this.getSeriesById(model[p]).code : '',
                value: model[p] ? this.getSeriesById(model[p]).id : ''
              }
              break
            case 'set':
              this.form[p] = {
                label: model[p] ? this.getSetById(model[p]).code : '',
                value: model[p] ? this.getSetById(model[p]).id : ''
              }
              break
            case 'location':
              this.form[p] = {
                label: model[p] ? this.getLocationById(model[p]).code : '',
                value: model[p] ? this.getLocationById(model[p]).id : ''
              }
              break
            default:
              this.form[p] = model[p]
          }
        }
        this.initialForm = JSON.stringify(this.form)
        this.loadingForm = false
      },
      /**
       * Resets the form to its original state
       */
      resetForm () {
        this.form.code = ''
        this.form.name = ''
        this.form.description = ''
        this.form.account_number = ''
        this.form.routing_number = ''
        this.form.account_fraction = ''
        this.form.currency = Object.assign({}, { label: '', value: '' })
        this.form.contact_name = ''
        this.form.branch_number = ''
        this.form.address_physical = ''
        this.form.address_physical_line1 = ''
        this.form.address_physical_line2 = ''
        this.form.address_physical_city = ''
        this.form.address_physical_state = Object.assign({}, { label: '', value: '' })
        this.form.address_physical_postal = ''
        this.form.address_mailing = ''
        this.form.address_mailing_line1 = ''
        this.form.address_mailing_line2 = ''
        this.form.address_mailing_city = ''
        this.form.address_mailing_state = Object.assign({}, { label: '', value: '' })
        this.form.address_mailing_postal = ''
        this.form.phone = ''
        this.form.fax = ''
        this.form.email = ''
        this.form.check_preferred_template = ''
        this.form.check_range_start = ''
        this.form.check_range_end = ''
        this.form.eft_range_start = ''
        this.form.eft_range_end = ''
        this.form.wt_range_start = ''
        this.form.wt_range_end = ''
        this.form.default_account_cash = Object.assign({}, { label: '', value: '' })
        this.form.default_account_clearing = Object.assign({}, { label: '', value: '' })
        this.form.default_account_deposits = Object.assign({}, { label: '', value: '' })
        this.form.default_account_discount = Object.assign({}, { label: '', value: '' })
        this.form.check_copies = 1
        this.form.eft_template = ''
        this.form.eft_copies = 1
        this.form.wt_template = ''
        this.form.wt_copies = 1
        this.form.series = Object.assign({}, { label: '', value: '' })
        this.form.series = Object.assign({}, { label: '', value: '' })
        this.form.set = Object.assign({}, { label: '', value: '' })
        this.form.positive_pay_email_notification = ''
      },
      /**
       * Gets dependencies that bank relies on
       * @return {Promise<any[]>}
       */
      getBankDependencies () {
        let missingAddresses = {}
        let promises = []
        this.pageData.forEach(v => {
          if (v.address_physical && !Object.keys(this.getAddressById(v.address_physical)).length) {
            missingAddresses[v.address_physical] = true
          }
          if (v.address_mailing && !Object.keys(this.getAddressById(v.address_mailing)).length) {
            missingAddresses[v.address_mailing] = true
          }
        })
        if (Object.keys(missingAddresses).length) {
          let addressesRequest = Object.assign({}, addressPayload, { query: { id__in: Object.keys(missingAddresses) } })
          promises.push(this.$store.dispatch('fetchWithQuery', addressesRequest))
        }
        return Promise.all(promises)
      },
      /**
       * Get default data if they are not in store
       */
      async getDefaultData () {
        let payloads = []
        const {
          getAllSets,
          getAllLocations,
          getAllSeries
        } = this.$store.getters

        if (!getAllSets.length) {
          payloads.push(setActionPayload)
        }
        if (!getAllLocations.length) {
          payloads.push(locationActionPayload)
        }
        if (!getAllSeries.length) {
          payloads.push(seriesActionPayload)
        }
        let dataLoader = new DataLoader(this.$store, payloads, true, 200)
        dataLoader.loadData()
      }
    },
    computed: {
      ...mapGetters({
        getBankById: 'getBankById',
        getAccountById: 'getAccountById',
        getCurrencyById: 'getCurrencyById',
        getAddressById: 'getAddressById',
        getStateById: 'getStateById',
        receiving: 'getBankFetchStatus',
        saving: 'getBankSaveStatus',
        saveFailure: 'getBankSaveFailure',
        updating: 'getBankUpdateStatus',
        navigating: 'getNavigationStatus',
        initialDataLoaded: 'getInitDataLoadedStatus',
        getSeriesById: 'getSeriesById',
        getSetById: 'getSetById',
        getLocationById: 'getLocationById',
        states: 'getAllStates',
        series: 'getAllSeries',
        locations: 'getAllLocations',
        sets: 'getAllSets'
      }),
      data () {
        return this.sortData(this.$store.getters.getAllBanks)
      },
      pageData () {
        return this.meetsFilterCriteria(this.data).slice((this.currentPage - 1) * 20, this.currentPage * 20)
      },
      meta () {
        return { count: this.meetsFilterCriteria(this.data).length, shown: this.pageData.length }
      },
      fields () {
        return [
          {
            label: 'Code',
            name: 'code',
            dataType: 'string',
            fieldType: 'input',
            required: true
          },
          {
            label: 'Name',
            name: 'name',
            dataType: 'string',
            fieldType: 'input',
            required: true,
            msg: 'Please specify a name'
          },
          {
            label: 'Description',
            name: 'description',
            dataType: 'string',
            fieldType: 'input'
          },
          {
            label: 'Account number',
            name: 'account_number',
            dataType: 'string',
            fieldType: 'input',
            required: true,
            msg: 'Please specify an account number'
          },
          {
            label: 'Routing number',
            name: 'routing_number',
            dataType: 'string',
            fieldType: 'input',
            required: true,
            msg: 'Please specify a routing number'
          },
          {
            label: 'Preferred check template',
            name: 'check_preferred_template',
            dataType: 'string',
            fieldType: 'input',
            required: false
          },
          {
            label: 'Account fraction',
            name: 'account_fraction',
            dataType: 'string',
            fieldType: 'input',
            required: true,
            msg: 'Please specify an account fraction'
          },
          {
            label: 'Currency',
            name: 'currency',
            dataType: 'string',
            fieldType: 'autocomplete',
            searchAsync: true,
            triggerOnFocus: false,
            required: true,
            msg: 'Please specify a currency'
          },
          {
            label: 'Contact name',
            name: 'contact_name',
            dataType: 'string',
            fieldType: 'input',
            msg: 'Please specify a contact name'
          },
          {
            label: 'Branch number',
            name: 'branch_number',
            dataType: 'string',
            fieldType: 'input',
            msg: 'Please specify a branch number'
          },
          {
            label: 'Physical address line 1',
            name: 'address_physical_line1',
            dataType: 'string',
            fieldType: 'input'
          },
          {
            label: 'Mailing address line 1',
            name: 'address_mailing_line1',
            dataType: 'string',
            fieldType: 'input',
            required: true
          },
          {
            label: 'Physical address line 2',
            name: 'address_physical_line2',
            dataType: 'string',
            fieldType: 'input'
          },
          {
            label: 'Mailing address line 2',
            name: 'address_mailing_line2',
            dataType: 'string',
            fieldType: 'input'
          },
          {
            label: 'Physical address city',
            name: 'address_physical_city',
            dataType: this.isCityModel ? 'number' : 'string',
            fieldType: 'input'
          },
          {
            label: 'Mailing address city',
            name: 'address_mailing_city',
            dataType: this.isCityModel ? 'number' : 'string',
            fieldType: 'input',
            required: true
          },
          {
            label: 'Physical address state',
            name: 'address_physical_state',
            dataType: 'string',
            fieldType: 'select',
            filterable: true,
            required: false,
            choices: [
              ...this.states.map(state => {
                return { display_name: state.name, value: state.id }
              })
            ]
          },
          {
            label: 'Mailing state',
            name: 'address_mailing_state',
            dataType: 'string',
            fieldType: 'select',
            filterable: true,
            required: true,
            choices: [
              ...this.states.map(state => {
                return { display_name: state.name, value: state.id }
              })
            ]
          },
          {
            label: 'Physical address postal',
            name: 'address_physical_postal',
            dataType: 'string',
            fieldType: 'input'
          },
          {
            label: 'Mailing postal',
            name: 'address_mailing_postal',
            dataType: 'string',
            fieldType: 'input',
            required: true
          },
          {
            label: 'Phone',
            name: 'phone',
            dataType: 'string',
            fieldType: 'input'
          },
          {
            label: 'Fax',
            name: 'fax',
            dataType: 'string',
            fieldType: 'input'
          },
          {
            label: 'Email',
            name: 'email',
            dataType: 'string',
            fieldType: 'input'
          },
          {
            label: '',
            name: '',
            dataType: 'string',
            fieldType: 'input',
            disabled: true
          },
          {
            label: 'Check range start',
            name: 'check_range_start',
            dataType: 'string',
            fieldType: 'input',
            required: true
          },
          {
            label: 'Check range end',
            name: 'check_range_end',
            dataType: 'string',
            fieldType: 'input',
            required: true
          },
          {
            label: 'Preferred check template',
            name: 'check_preferred_template',
            dataType: 'string',
            fieldType: 'input',
            required: false
          },
          {
            label: 'Check copies',
            name: 'check_copies',
            fieldType: 'input',
            required: false
          },
          {
            label: 'EFT range start',
            name: 'eft_range_start',
            dataType: 'string',
            fieldType: 'input',
            required: true
          },
          {
            label: 'EFT range end',
            name: 'eft_range_end',
            dataType: 'string',
            fieldType: 'input',
            required: true
          },
          {
            label: 'EFT Template',
            name: 'eft_template',
            dataType: 'string',
            fieldType: 'input',
            required: false
          },
          {
            label: 'EFT Copies',
            name: 'eft_copies',
            fieldType: 'input',
            required: true
          },
          {
            label: 'Wire transfer range start',
            name: 'wt_range_start',
            dataType: 'string',
            fieldType: 'input',
            required: false
          },
          {
            label: 'Wire transfer range end',
            name: 'wt_range_end',
            dataType: 'string',
            fieldType: 'input',
            required: false
          },
          {
            label: 'Wire Transfer Template',
            name: 'wt_template',
            dataType: 'string',
            fieldType: 'input',
            required: false
          },
          {
            label: 'Wire Transfer Copies',
            name: 'wt_copies',
            fieldType: 'input',
            required: true
          },
          {
            label: 'Default account cash',
            name: 'default_account_cash',
            dataType: 'string',
            fieldType: 'autocomplete',
            searchAsync: true,
            triggerOnFocus: false,
            required: true
          },
          {
            label: 'Default account clearing',
            name: 'default_account_clearing',
            dataType: 'string',
            fieldType: 'autocomplete',
            searchAsync: true,
            triggerOnFocus: false,
            required: true
          },
          {
            label: 'Default account deposits',
            name: 'default_account_deposits',
            dataType: 'string',
            fieldType: 'autocomplete',
            searchAsync: true,
            triggerOnFocus: false,
            required: true
          },
          {
            label: 'Default account discount',
            name: 'default_account_discount',
            dataType: 'string',
            fieldType: 'autocomplete',
            searchAsync: true,
            triggerOnFocus: false,
            required: true
          },
          {
            label: 'Series',
            name: 'series',
            dataType: 'string',
            fieldType: 'select',
            filterable: true,
            required: false,
            choices: [
              ...this.series.map((series) => {
                return { display_name: series.name, value: series.id }
              })
            ]
          },
          {
            label: 'Location',
            name: 'location',
            dataType: 'string',
            fieldType: 'select',
            filterable: true,
            required: false,
            choices: [
              ...this.locations.map((location) => {
                return { display_name: location.name, value: location.id }
              })
            ]
          },
          {
            label: 'Set',
            name: 'set',
            dataType: 'string',
            fieldType: 'select',
            filterable: true,
            required: false,
            choices: [
              ...this.sets.map((set) => {
                return { display_name: set.name, value: set.id }
              })
            ]
          },
          {
            label: 'Positive Pay Email Notification',
            name: 'positive_pay_email_notification',
            dataType: 'string',
            fieldType: 'input'
          }
        ]
      }
    },
    watch: {
      pageData () {
        if (this.initialDataLoaded && this.pageData.length) {
          this.getBankDependencies()
        }
      }
    },
    mounted () {
      const tableHeight = () => {
        const parentHeight = document.getElementById('banks').offsetHeight
        const headerHeight = document.getElementById('banks-header').offsetHeight
        return parentHeight - headerHeight
      }
      this.tableHeight = tableHeight()
      if (this.initialDataLoaded && this.pageData.length) {
        this.getBankDependencies()
      }
      try {
        this.checkCityModel()
      } catch (error) {
        // It's ok.
        // console.log('No cities')
      }
      this.getDefaultData()
    },
    beforeDestroy () {
      this.$store.dispatch('clearFilters')
    },
    async beforeRouteEnter (to, from, next) {
      try {
        if (from.path !== '/') {
          let dataLoader = new DataLoader(store, [ bankActionPayload ], true, 200)
          await dataLoader.loadData()
        }
      } catch (e) {
        console.log(e)
      } finally {
        next()
      }
    },
    created () {
      this.endpoint = bankActionPayload.endpoint
      this.moduleName = bankActionPayload.moduleName
      // this.payload = bankActionPayload
    }
  }
</script>

<style scoped>
  #banks-header {
    border-bottom: 1px solid lightgray;
  }
  .h-padded {
    padding: 0 12px;
  }
  .right-aligned-col {
    text-align: right;
  }
  .el-table .modified-row {
    background: #c9e5f5;
  }
  #banks .dialog__footer {
    text-align: right !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/RouteComponents/Banks/Banks.vue